import "./JudgePanel.scss";
import Control from "../../../1. Core/Control";
import {IBattle} from "../../types";

interface AIEvent {
    Points: number
    Name: string
    Time: string
}

interface AIStat {
    Events: AIEvent[]
    Intencity: number
    IntencityTrown: number
    GroundControlPoints: number
    GrappleControlPoints: number
}

interface RoundData {
    redTotal: number
    blueTotal: number
    redPoints: number
    bluePoints: number
    red: AIStat
    blue: AIStat
}

export default class JudgePanel extends Control {

    private _Round: number;
    private _BattleId: string;
    private _roundData: RoundData[];
    private _Battle: IBattle;

    private _dataNode: HTMLElement;
    private _tableNode: HTMLElement;

    _initFields(settings: object) {
        this._Round = 0
        this._BattleId = ""
        this._Battle = null
        super._initFields(settings);
    }

    constructor(settings?: object) {
        super(settings);
        this._render();
    }

    _render() {
        this._initComponent(`<div>
        <div class="judge_name_node"><span style="color: #E74342">${this._Battle.RedName}</span> <span style="color: #2962FF"> ${this._Battle.BlueName} </span></div>
        <div class="data_node"></div>
        <div class="judge_table_node"></div>
        </div>`);

        this._dataNode = this._root.querySelector('.data_node')
        this._tableNode = this._root.querySelector('.judge_table_node')

        this._roundData = new Array(this._Round).fill(null);

        if (this._ParentNode)
            this.putToNode(this._ParentNode);

    }

    async refresh() {
        for (let i = 1; i < this._Round; i++) {
            if (!this._roundData[i - 1]) {
                this.loadRound(i)
            }
        }

        this.loadRound(this._Round)
    }

    async loadRound(round: number) {
        const response = await fetch(window.location.origin + `/api/v1/mma_ai/${this._BattleId}?round=${round}&advanced=1`, {
            method: 'GET',
            cache: 'no-cache',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            }
        })
        const data = await response.json()
        this._roundData[round - 1] = data

        this.renderTable()
    }


    setRound(round: number) {
        this._Round = round
        this.refresh()
    }


    renderTable() {
        if (!this._roundData?.length)
            return

        let htmls = []
        for (let i = 0; i < this._roundData.length; i++) {
            let roundData = this._roundData[i]
            if (!roundData)
                continue

            let htmlRed = this.renderEvents(roundData.red)
            let htmlbLue = this.renderEvents(roundData.blue)

            htmls.push(`<div class="judge_round_root"> Round ${i + 1}</div>`)
            htmls.push(`<div class="judge_round_root"> ${htmlRed} ${htmlbLue}</div>`)
            htmls.push(`<div class="judge_round_root" style="border-bottom: 1px solid #9E9E9E"> ${this.renderTotal(roundData.redPoints, roundData.redTotal)} ${this.renderTotal(roundData.bluePoints, roundData.blueTotal)}</div>`)
        }


        this._dataNode.innerHTML = htmls.join('')

        this._tableNode.innerHTML = this.renderTotalTable()
    }

    renderTotal(points: number, total: number) {
        return `
            <div class="judge_round" style="font-weight: 600;">
                <div>${total} Total</div>
                <div>${points} Points</div>
            </div>`
    }

    renderEvents(stat: AIStat) {

        let items = []

        for (let i = 0; i < stat.Events.length; i++) {
            let event = stat.Events[i]
            items.push(`<div>+${event.Points} ${event.Name} ${event.Time}</div>`)
        }

        return `
            <div class="judge_round">
                ${items.join('')}
                <div>+${stat.Intencity} Intencity</div>
                <div>+${stat.IntencityTrown} Intencity Trown</div>
                <div>+${stat.GroundControlPoints} Ground Control Points</div>
                <div>+${stat.GrappleControlPoints} Grapple Control Points</div>
            </div>`
    }

    renderTotalTable() {

        let html = `<table class="judge_table">`
        html += `<tr><td>Athlete</td>`
        for (let i = 0; i < this._roundData.length; i++) {
            html += `<td>${i + 1} round</td>`
        }
        html += `<td>Total</td>`
        html += `</tr>`
        html += `<tr><td style="color: #E74342">${this._Battle.RedName}</td>`
        let sum = 0
        for (let i = 0; i < this._roundData.length; i++) {
            let points = this._roundData[i]?.redPoints || 0
            html += `<td style="color: #E74342">${points}</td>`
            sum += points
        }
        html += `<td style="color: #E74342">${sum}</td>`

        html += `</tr>`
        html += `<tr><td style="color: #2962FF">${this._Battle.BlueName}</td>`
        sum = 0
        for (let i = 0; i < this._roundData.length; i++) {
            let points = this._roundData[i]?.bluePoints || 0
            html += `<td style="color: #2962FF">${points}</td>`
            sum += points
        }
        html += `<td style="color: #2962FF">${sum}</td>`


        html += `</tr>`
        html += `</table>`
        return html
    }
}